module.exports = __webpack_public_path__ + "static/media/Hair_1_blond.e82b45ef.svg";